module.exports = __webpack_public_path__ + "images/maybe-not-gif.gif";